import React from 'react';
import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { Card, Info, Brand, Model, PriceRow, Meta, MenuButton } from '../ProductMobileList/ProductCard.style';

export interface MobileCardAction {
  key: string;
  label: string;
  icon?: React.ReactNode;
  danger?: boolean;
  divider?: boolean;
  onClick: () => void;
}

interface MobileCardProps {
  overline?: React.ReactNode;
  title: React.ReactNode;
  highlight?: React.ReactNode;
  meta?: React.ReactNode;
  actions: MobileCardAction[];
  onOpen: () => void;
  testId: string;
}

const MobileCard: React.FC<MobileCardProps> = ({ overline, title, highlight, meta, actions, onOpen, testId }) => {
  const tapSize = { paddingTop: 11, paddingBottom: 11 };
  const items: MenuProps['items'] = actions.flatMap((action) => [
    ...(action.divider ? [{ type: 'divider' as const }] : []),
    { key: action.key, icon: action.icon, label: action.label, danger: action.danger, style: tapSize },
  ]);
  const onMenuClick: MenuProps['onClick'] = ({ key, domEvent }) => {
    domEvent.stopPropagation();
    actions.find((action) => action.key === key)?.onClick();
  };

  return (
    <Card onClick={onOpen} data-testid={testId}>
      <Info>
        {overline && <Brand>{overline}</Brand>}
        <Model>{title}</Model>
        {highlight && <PriceRow>{highlight}</PriceRow>}
        {meta && <Meta>{meta}</Meta>}
      </Info>
      <MenuButton onClick={(e) => e.stopPropagation()}>
        <Dropdown menu={{ items, onClick: onMenuClick }} trigger={['click']} placement="bottomRight">
          <Button type="text" icon={<MoreOutlined style={{ fontSize: 20 }} />} aria-label="Aktionen" data-testid={`${testId}-menu`} />
        </Dropdown>
      </MenuButton>
    </Card>
  );
};

export default MobileCard;
